module.exports = __webpack_public_path__ + "img/man-in-saleshat@2x.479da89.webp";